export { EventLogs } from './event_logs.js';
export function titleCase(input) {
    if (!input || !input.length)
        return '';
    return input.charAt(0).toUpperCase() + input.slice(1);
}
const latinCharMap = {
    ł: 'l',
    Ł: 'L',
    ø: 'o',
    Ø: 'O',
    đ: 'd',
    Đ: 'D',
    ð: 'd',
    Ð: 'D',
    þ: 'th',
    Þ: 'Th',
    ß: 'ss',
    æ: 'ae',
    Æ: 'Ae',
    œ: 'oe',
    Œ: 'Oe',
};
export function removeDiacritics(str) {
    return str
        .replace(/[łŁøØđĐðÐþÞßæÆœŒ]/g, c => latinCharMap[c] ?? c)
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '');
}
export function toSortableField(input) {
    if (!input)
        return '';
    return removeDiacritics(input).toLowerCase();
}
export function pickTimestampFromUserActions(userActions) {
    return userActions.createdAt || userActions.updatedAt || userActions.deletedAt || Date.now();
}
export function pickActorFromUserActions(userActions) {
    return userActions.createdBy || userActions.updatedBy || userActions.deletedBy;
}
//# sourceMappingURL=index.js.map